export default __webpack_public_path__ + "static/media/coin.eada9dcb.mp4";